import { Injectable, APP_INITIALIZER } from '@angular/core';
import { IEnvironment } from 'src/app/shared/models/environment-interface/i-environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentResolveService {
  private _dynamicEnvironment: IEnvironment;

  constructor() { }

  setEnvironment(env: Observable<IEnvironment>){
    env.subscribe(
      (data: IEnvironment) => this._dynamicEnvironment = { ...data }
    );
  }

  get environmentERS(): IEnvironment {
    return this._dynamicEnvironment;
  }

}
